import bffMultiRequest from '../../shared/bffMultiRequest';

const generateTransactionId = data => {
  return bffMultiRequest([
    {
      url: 'bff-payment-management/v1/oneclick/debt',
      method: 'POST',
      data,
    },
  ]);
};

const PaymentServices = {
  generateTransactionId,
};

export default PaymentServices;
